/**
 * formatCHF
 * Reçoit un montant en centimes (entier) et retourne une chaîne formatée.
 * Règle 2026-02-05 : La UI formate, la logique métier calcule en cents.
 */
export const formatCHF = (cents) => {
  // Sécurité : conversion en nombre et gestion du cas null/undefined
  const amountInCents = Number(cents) || 0;

  // Conversion des centimes en francs avec 2 décimales
  // 800 cents / 100 = 8.00 CHF
  return (amountInCents / 100).toFixed(2) + " CHF";
};
